import React from "react";
import "./choose.scss";

const ITEMS = [
  {
    title: "Senior team",
    body: "Every project is led by people who have shipped production systems. No juniors learning on your budget.",
    icon: "/assets/figma/icon-team.svg",
  },
  {
    title: "Tailored architecture",
    body: "Stack and process fitted to your goals and constraints. No templates, no one-size-fits-all.",
    icon: "/assets/figma/icon-arch.svg",
  },
  {
    title: "Quality gates",
    body: "Code review, automated testing, and staging on every release. Quality is a process, not a promise.",
    icon: "/assets/figma/icon-quality.svg",
  },
  {
    title: "Long-term partners",
    body: "We measure success by what happens after launch: uptime, iteration speed, and clients who come back.",
    icon: "/assets/figma/icon-partners.svg",
  },
];

const Choose = () => {
  return (
    <section id="choose" className="mz-why mz-grid">
      <div className="mz-wrap mz-why__inner">
        <div className="mz-why__header">
          <div className="mz-chip">WHY MEZADA</div>
          <h2 className="mz-why__title">Built like we own it.</h2>
        </div>
        <div className="mz-why__row">
          {ITEMS.map((item) => (
            <div key={item.title} className="mz-why__item">
              <div className="mz-why__icon">
                <img src={item.icon} alt="" />
              </div>
              <div className="mz-why__copy">
                <h3 className="mz-why__name">{item.title}</h3>
                <p className="mz-why__body">{item.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Choose;
